module.exports = __webpack_public_path__ + "static/media/AverageCostPerKeg.a4358bb1.svg";